import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

// Extend dayjs with UTC and timezone plugins globally
dayjs.extend(utc);
dayjs.extend(timezone);

// Malaysia timezone constant
const MALAYSIA_TZ = "Asia/Kuala_Lumpur";

// Override the original dayjs function to always use Malaysia timezone
const originalDayjs = dayjs;
const dayjsWithMalaysiaTZ = function (date?: any, ...args: any[]) {
  // Call original dayjs and convert to Malaysia timezone
  if (date === undefined || date === null) {
    return originalDayjs().tz(MALAYSIA_TZ);
  }
  if (originalDayjs.isDayjs(date)) {
    return date.tz(MALAYSIA_TZ);
  }
  return originalDayjs(date, ...args).tz(MALAYSIA_TZ);
} as typeof dayjs;

// Copy all properties and methods from original dayjs to the wrapper
Object.keys(originalDayjs).forEach((key) => {
  (dayjsWithMalaysiaTZ as any)[key] = (originalDayjs as any)[key];
});

// Set prototype
Object.setPrototypeOf(
  dayjsWithMalaysiaTZ,
  Object.getPrototypeOf(originalDayjs)
);

// Store the timezone constant
(dayjsWithMalaysiaTZ as any).MALAYSIA_TZ = MALAYSIA_TZ;

// Export the configured dayjs with Dayjs type
export default dayjsWithMalaysiaTZ;
export type { Dayjs };
export { MALAYSIA_TZ };
